import React from "react";
import PropTypes from "prop-types";

const AuditLogsPage = (props) => {
  return (
    <>
      <div className="container">
        <h3 className="mb-45">Audit Logs</h3>

        <div className="row row-xs align-items-center mb-4">
          <div className="col-12 col-md-4 col-xl-2 mb-2">
            <input
              className="fin-control fin-control-sm"
              type="search"
              placeholder="Search keyword"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-2 mb-2">
            <select className="fin-control fin-control-sm">
              <option>User</option>
            </select>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-2 mb-2">
            <select className="fin-control fin-control-sm">
              <option>Model</option>
            </select>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-2 mb-2">
            <select className="fin-control fin-control-sm">
              <option>Event type</option>
              <option>Create</option>
              <option>Update</option>
              <option>Delete</option>
            </select>
          </div>
        </div>

        <table className="table-list vertical-top">
          <thead>
            <tr>
              <th style={{ width: "1%" }}>ID</th>
              <th style={{ width: "1%" }}>TIMESTAMP</th>
              <th style={{ width: "1%" }}>USER</th>
              <th style={{ width: "1%" }}>MODEL</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody className="text-xsmall text-body">
            <tr>
              <td>1</td>
              <td>
                <span className="nowrap">04/01/2021, 16:12</span>
              </td>
              <td>
                <span
                  className="tooltop"
                  data-tooltip="tooltip"
                  data-placement="top"
                  data-html="true"
                  title="Nick Sotiriadis<br>Finclude"
                >
                  nsotiriadis@finclude.ai
                </span>
              </td>
              <td>ORG</td>
              <td>
                <p className="mb-1">
                  <strong className="text-link">CREATE</strong> Incididunt a
                  ipsum. Se expetendis ne commodo sed aliquip comprehenderit te
                  senserit. Aut summis laborum, se ut despicationes ad do ne
                  nulla proident.
                </p>
                <a className="link-color">Revert to previous state</a>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>
                <span className="nowrap">04/01/2021, 16:12</span>
              </td>
              <td>
                <span
                  className="tooltop"
                  data-tooltip="tooltip"
                  data-placement="top"
                  data-html="true"
                  title="Nick Sotiriadis<br>Finclude"
                >
                  nsotiriadis@finclude.ai
                </span>
              </td>
              <td>USER</td>
              <td>
                <p className="mb-1">
                  <strong className="text-link">UPDATE</strong> Incididunt a
                  ipsum. Se expetendis ne commodo sed aliquip comprehenderit te
                  senserit. Aut summis laborum, se ut despicationes ad do ne
                  nulla proident.
                </p>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>
                <span className="nowrap">04/01/2021, 12:41</span>
              </td>
              <td>
                <span
                  className="tooltop"
                  data-tooltip="tooltip"
                  data-placement="top"
                  data-html="true"
                  title="Yiannis Giokas<br>Finclude"
                >
                  ygiokas@finclude.ai
                </span>
              </td>
              <td>ORG</td>
              <td>
                <p className="mb-1">
                  <strong className="text-link-alt">DELETE</strong> Incididunt a
                  ipsum. Se expetendis ne commodo sed aliquip.
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <ul className="pagination mt-45">
          <li className="active">
            <span className="current" tabIndex="-1">
              1
            </span>
          </li>
          <li>
            <a href="#" tabIndex="-1">
              2
            </a>
          </li>
          <li>
            <a href="#" tabIndex="-1">
              3
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

AuditLogsPage.propTypes = {};

export default AuditLogsPage;
